import React, { memo } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import {
  isDayClosed,
  openingClosingHours
} from '../../../../shared/utils/store/store';

import styles from './store-hours.scss';

function StoreHours(props) {
  const { selectedDate, weekDays } = props;

  return (
    <ol className="store-hours">
      {Array.isArray(weekDays) &&
        selectedDate &&
        weekDays.map((day, idx) => {
          const selectedDayOfWeek = format(
            selectedDate || '',
            'dddd'
          ).toUpperCase();
          const dayOfWeek = format(day?.formattedDate || '', 'dddd');
          const date = format(day?.formattedDate || '', 'M/D');
          const isClosed = isDayClosed(day);
          let rowClassName = isClosed ? 'closed-day' : 'day';

          if (selectedDayOfWeek === dayOfWeek.toUpperCase() && isClosed) {
            rowClassName = 'selected-closed-day';
          } else if (selectedDayOfWeek === dayOfWeek.toUpperCase()) {
            rowClassName = 'selected-day';
          }

          return (
            <li className={styles[rowClassName]} key={`wd-${idx}`}>
              <span className={styles['day-of-week']}>{dayOfWeek}</span>
              <span className={styles['date']}>{date}</span>
              {isClosed ? (
                <span className={styles['week-hours']}>CLOSED</span>
              ) : (
                <span className={styles['week-hours']}>
                  {openingClosingHours(day)}
                </span>
              )}
            </li>
          );
        })}
    </ol>
  );
}

StoreHours.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  weekDays: PropTypes.arrayOf(
    PropTypes.shape({
      closingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      }),
      formattedDate: PropTypes.string,
      openingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      })
    })
  )
};

export default memo(StoreHours);
